// action types
export const ADD_SERVICE = 'ADD_SERVICE';
export const UPDATE_SERVICE = 'UPDATE_SERVICE';
export const REMOVE_SERVICE = 'REMOVE_SERVICE';
export const ADD_REALISATION = 'ADD_REALISATION';
export const UPDATE_REALISATION = 'UPDATE_REALISATION';
export const REMOVE_REALISATION = 'REMOVE_REALISATION';
export const ADD_PHOTO = 'ADD_PHOTO';
export const REMOVE_PHOTO = 'REMOVE_PHOTO';
export const CLEAR_SERVICES = 'CLEAR_SERVICES';
export const ADD_SERVICE_COMPLEMENTAIRE = 'ADD_SERVICE_COMPLEMENTAIRE';
export const REMOVE_SERVICE_COMPLEMENTAIRE = 'REMOVE_SERVICE_COMPLEMENTAIRE';

// action creators

export const addService = (service) => ({
  type: ADD_SERVICE,
  payload: {
    ...service,
    id: Date.now().toString(), // id temporaire côté front
  },
});

export const updateService = (index, data) => ({
  type: UPDATE_SERVICE,
  payload: { index, data },
});

export const removeService = (index) => ({
  type: REMOVE_SERVICE,
  payload: index,
});

export const addRealisation = (serviceIndex, realisation) => ({
  type: ADD_REALISATION,
  payload: {
    serviceIndex,
    realisation: {
      ...realisation,
      id: Date.now().toString(),
    },
  },
});

export const updateRealisation = (serviceIndex, realisationIndex, data) => ({
  type: UPDATE_REALISATION,
  payload: { serviceIndex, realisationIndex, data },
});

export const removeRealisation = (serviceIndex, realisationIndex) => ({
  type: REMOVE_REALISATION,
  payload: { serviceIndex, realisationIndex },
});

export const addPhoto = (serviceIndex, realisationIndex, photo) => ({
  type: ADD_PHOTO,
  payload: {
    serviceIndex,
    realisationIndex,
    photo: {
      ...photo,
      id: Date.now().toString(),
    },
  },
});

export const removePhoto = (serviceIndex, realisationIndex, photoIndex) => ({
  type: REMOVE_PHOTO,
  payload: { serviceIndex, realisationIndex, photoIndex },
});

export const clearServices = () => ({
  type: CLEAR_SERVICES,
});

/**
 * Nouvelle action pour ajouter un service complémentaire
 */
export const addServiceComplementaire = (serviceId, complementaire) => ({
  type: ADD_SERVICE_COMPLEMENTAIRE,
  payload: {
    serviceId,
    complementaire: {
      ...complementaire,
      id: Date.now().toString(),
    },
  },
});

export const removeServiceComplementaire = (serviceId, complementaireId) => ({
  type: REMOVE_SERVICE_COMPLEMENTAIRE,
  payload: { serviceId, complementaireId },
});

